import { render, staticRenderFns } from "./gzzoc-fundus-img-quality.vue?vue&type=template&id=6f7dddc0&scoped=true&lang=pug&"
import script from "./gzzoc-fundus-img-quality.vue?vue&type=script&lang=js&"
export * from "./gzzoc-fundus-img-quality.vue?vue&type=script&lang=js&"
import style0 from "./gzzoc-fundus-img-quality.vue?vue&type=style&index=0&id=6f7dddc0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7dddc0",
  null
  
)

export default component.exports